import LinkWithArrow from './Component';

export default LinkWithArrow;